import { ROUTE } from "../../../routes";
export const needHelp = async (action, _datastore, { navigate, instrumentTrack }) => {
    instrumentTrack('CONTACT_US_BUTTON_CLICKED');
    await navigate(ROUTE.CONTACT_US_CARD);
};
export const goBack = async (action, _datastore, { goBack, navigateWithClear }) => {
    await navigateWithClear(ROUTE.DASHBOARD);
};
export const navigateToShortfallRepayScreen = async (action, _datastore, { goBack, navigate }) => {
    const shortfallDetails = action?.payload.shortfallDetails;
    await navigate(ROUTE.SHORTFALL_REPAY_SCREEN, { shortfallDetails });
};
export const navigateToShortfallInfoScreen = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.SHORTFALL_INFO_SCREEN);
};
